<template>
  <div class="setup-content contact-info" id="step-4">
    <div class="form-row justify-content-between">
      <div class="d-flex align-items-center">
        <h3 class="color-darkblue mr-4">Parts</h3>
        <div class="no-parts-used-checkbox form-check mb-1">
          <input type="checkbox" class="form-check-input" v-model="noPartsUsed" id="no_parts_used"
            @change="rootCausePartChecked(null, 'no-parts')" :disabled="disableAllFields || claimStatus == 'In Process'">
          <label class="form-check-label" for="no_parts_used">No Parts Used</label>
        </div>
      </div>
      <div v-if="viewAllfields" class="verified-checkbox mr-4">
        <div class="form-group row claim-verified-checkbox pt-7">
          <label for="part_section_verified" class="control-label claim-mr-2">Verified:</label>
          <input type="checkbox" v-model="section_verified" :disabled="disableAllFields" name="part_section_verified" id="part_section_verified" />
        </div>
      </div>
    </div>
    <div class="table-responsive-sm mt-2">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" style="width: 4%;">Parts Line #</th>
            <th scope="col" style="width: 10%;">Part Number</th>
            <th scope="col" style="width: 20%;" class="text-left">Part Description</th>
            <th scope="col" class="text-left">QTY</th>
            <th scope="col" class="text-left">Warranty Price</th>
            <th scope="col" class="text-left">Line Total</th>
            <th scope="col" style="width: 4%;" class="text-left">Root Cause Part?</th>
            <!-- the fields below should be visible only to the admin users -->
            <th scope="col" class="text-left">Approval Status</th>
            <th scope="col" class="text-left">Approval</th>
            <th scope="col" class="text-left">Disposition</th>
            <th scope="col" style="width: 55px;"> Action </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <v-select v-model="row.part" :id="'part_' + index" :name="'part_' + index" label="text"
                :options="componentArr" @search="onSearchComponent" placeholder="Select Part"
                class='custom-ci-auto-search contract-data' :disabled="dealerFieldsDisabled || disableAllFields"
                @input="populatePartsDescription(index), handlePartNumberChange(index)"
                @change="partNumberChanged($event, index)">
                <template slot="no-options">
                  Search Parts...
                </template>
                <template slot="option" slot-scope="option">
                  <div class="d-center">
                    {{ option.text }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="option">
                  <div class="selected d-center">
                    {{ option.text }}
                  </div>
                </template>
              </v-select>
              <div class="field-error ml-0">{{ row.part_number_error_msg }}</div>
            </td>
            <td>
              <div class="row">
                <div class=col-12>
                  <input type="text" disabled placeholder="Part Description" v-model="row.partDescription"
                    id="partDescription" name="partDescription" style="width:99% !important" class="vgt-input">
                </div>
                <div class="col-12" v-if="row.approval_status == 'Rejected'">
                  Rejection Reason
                </div>
                <div class="col-12" v-if="row.approval_status == 'Rejected'">
                  <input type="text" placeholder="Rejection Reason" v-model="row.rejectionReason"
                    style="width:100% !important" :id="'rejectionReason' + index" :name="'rejectionReason' + index"
                    class="vgt-input" :disabled="disableAllFields">
                  <div class="field-error ml-0">{{ row.rejectionReasonErrorMsg }}</div>
                </div>
              </div>
            </td>
            <td>
              <input type="number" placeholder="QTY" v-model="row.qty" :id="'qty' + index" style="width:99% !important"
                v-on:keyup="calculatePartsAmount()" :name="'qty' + index" class="vgt-input text-right"
                :disabled="dealerFieldsDisabled || disableAllFields" @keypress="filterNumericValue">
              <div class="field-error ml-0">{{ row.qty_error_msg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Warranty Price" v-model="row.warranty_price"
                v-on:keyup="calculatePartsAmount()" :id="'warranty_price' + index" :name="'warranty_price' + index"
                style="width:99% !important" class="vgt-input text-right" @keypress="filterNumericValue"
                :disabled="true">
              <div class="field-error ml-0">{{ row.warranty_price_error_msg }}</div>
            </td>
            <td>
              <input type="text" disabled placeholder="Line Total" v-model="row.line_total" :id="'line_total' + index"
                :name="'line_total' + index" style="width:99% !important" class="vgt-input text-right">
            </td>
            <td class="checkbox-container">
              <input type="checkbox" v-model="row.root_cause_part" name="root_cause_part" id="root_cause_part"
                @change="rootCausePartChecked(index)" :disabled="disableAllFields || claimStatus == 'In Process'"/>
              <div class="field-error ml-0">{{ row.root_cause_part_error_msg }}</div>
            </td>
            <td>
              <v-select class="close-remove" v-model="row.approval_status" id="approval_status" name="approval_status"
                placeholder="Select Approval Status" label="text" :options="approvalStatusArr"
                :disabled="!viewAllfields || disableAllFields" @change="partApprovalStatusChanged($event, index)">
              </v-select>
              <div class="field-error ml-0">{{ row.approval_status_error_msg }}</div>
            </td>
            <td>
              <input type="text" placeholder="Approval Price" v-model="row.approval_price"
                :id="'approval_price' + index" :name="'approval_price' + index" style="width:99% !important"
                class="vgt-input text-right" v-on:keyup="calculatePartsAmount()" :disabled="!viewAllfields || disableAllFields || claimStatus == 'In Process'"
                @keypress="filterNumericValue">
              <div class="field-error ml-0">{{ row.approval_price_error_msg }}</div>
            </td>
            <td>
              <v-select class="close-remove" v-model="row.disposition" id="disposition" name="disposition"
                placeholder="Select Disposition" label="text" :options="dispositionArr" :disabled="!viewAllfields || disableAllFields">
              </v-select>
            </td>
            <td class="text-center valign-middle">
              <template v-if="rows.length > 1 && userObj.id == row.created_by">
                <a href="javascript:void(0);" :class="{ 'custom-disabled-link': disableAllFields || claimStatus == 'In Process' }" v-on:click="removeItem(index);"> <i class="fp-delete"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <template>
        <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary" :disabled="noPartsUsed || disableAllFields || claimStatus == 'In Process'">
          <i class="fp-add"></i> Add another Part
        </button>
      </template>

      <template>
        <button type="submit" v-on:click.prevent="showNonOemSection()" class="btn btn-primary" :disabled="noPartsUsed || disableAllFields || claimStatus == 'In Process'">
          <i class="fp-add"></i> Add NON-OEM Parts
        </button>
      </template>
    </div>

    <template v-if="displayNonOemPartSection">
      <div>
        <h3 class="color-darkblue">Non-OEM Parts</h3>
        <div class="table-responsive-sm mt-2">
          <table class="table table-bordered table-sm" style="table-layout: fixed;">
            <thead>
              <tr class="table-primary">
                <th scope="col" style="width: 4%;">Line #</th>
                <th scope="col" style="width: 10%;">Part Number</th>
                <th scope="col" style="width: 20%;">Part Description</th>
                <th scope="col" class="text-left required">QTY</th>
                <th scope="col" class="text-left required">Dealer cost</th>
                <th scope="col" class="text-left">Total Requested</th>
                <th scope="col" class="text-left">Reason</th>
                <!-- the fields below should be visible only to the admin users -->
                <th scope="col" class="text-left">Approval Status</th>
                <th scope="col" class="text-left">Approval</th>
                <th scope="col" class="text-left">Disposition</th>
                <th scope="col"> Action </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in oem_rows" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  <input type="text" placeholder="Part Number" v-model="row.partNumber" style="width:99% !important"
                    :id="'partNumber' + index" :name="'partNumber' + index" class="vgt-input require"
                    :disabled="disableAllFields || claimStatus == 'In Process'">
                  <div class="field-error ml-0">{{ row.part_number_error_msg }}</div>
                </td>
                <td>
                  <div class="row">
                    <div class="col-12">
                      <input type="text" placeholder="Part Description" v-model="row.partDescription"
                        style="width:99% !important" :id="'partDescription' + index" :name="'partDescription' + index"
                        class="vgt-input require" :disabled="disableAllFields || claimStatus == 'In Process'">
                    </div>
                    <div class="col-12" v-if="row.approvalStatus == 'Rejected'">
                      Rejection Reason
                    </div>
                    <div class="col-12" v-if="row.approvalStatus == 'Rejected'">
                      <input type="text" placeholder="Rejection Reason" v-model="row.rejectionReason"
                        style="width:100% !important" :id="'rejectionReason' + index" :name="'rejectionReason' + index"
                        class="vgt-input" :disabled="disableAll || disableAllFields">
                      <div class="field-error ml-0">{{ row.rejectionReasonErrorMsg }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <input type="number" placeholder="QTY" v-model="row.qty" :id="'qty' + index"
                    style="width:99% !important" :name="'qty' + index" class="vgt-input text-right"
                    v-on:keyup="calculateNonOemPartsAmount()" :disabled="disableAll || disableAllFields || claimStatus == 'In Process'" @keypress="filterNumericValue">
                  <div class="field-error ml-0">{{ row.qty_error_msg }}</div>
                </td>
                <td>
                  <input type="text" placeholder="Dealer Cost" v-model="row.dealerCost" :id="'dealerCost' + index"
                    :name="'dealerCost' + index" style="width:99% !important" class="vgt-input text-right"
                    v-on:keyup="calculateNonOemPartsAmount()" :disabled="disableAll || disableAllFields || claimStatus == 'In Process'" @keypress="filterNumericValue">
                  <div class="field-error ml-0">{{ row.dealer_cost_error_msg }}</div>
                </td>
                <td>

                  <input type="text" disabled placeholder="Total Requested" v-model="row.requested_total"
                    :id="'requested_total' + index" :name="'requested_total' + index" style="width:99% !important"
                    class="vgt-input text-right" @keypress="filterNumericValue">
                </td>
                <td>
                  <input type="text" placeholder="Reason" v-model="row.reason" id="reason" name="reason"
                    style="width:99% !important" class="vgt-input" :disabled="disableAllFields || claimStatus == 'In Process'">
                  <div class="field-error ml-0">{{ row.reason_error_msg }}</div>
                </td>
                <!-- the fields below should be visible only to the admin users -->
                <td>
                  <v-select class="close-remove" v-model="row.approvalStatus" :disabled="!viewAllfields || disableAllFields"
                    id="approvalStatus" name="approvalStatus" placeholder="Select Approval Status" label="text"
                    :options="approvalStatusArr" @change="nonOemPartApprovalStatusChanged($event, index)">
                  </v-select>
                  <div class="field-error ml-0">{{ row.approval_status_error_msg }}</div>
                </td>
                <td>
                  <input type="text" placeholder="Approval Price" v-model="row.approvalPrice" id="approvalPrice"
                    v-on:keyup="calculateNonOemPartsAmount()" name="approvalPrice" style="width:99% !important"
                    class="vgt-input text-right" @keypress="filterNumericValue" :disabled="!viewAllfields || disableAllFields || claimStatus == 'In Process'">
                  <div class="field-error ml-0">{{ row.approval_price_error_msg }}</div>
                </td>
                <td>
                  <v-select class="close-remove" v-model="row.disposition" :disabled="!viewAllfields || disableAllFields" id="disposition"
                    name="disposition" placeholder="Select Disposition" label="text" :options="dispositionArr">
                  </v-select>
                </td>
                <td class="text-center valign-middle">
                  <template v-if="userObj.id == row.created_by">
                    <a href="javascript:void(0);" :class="{ 'custom-disabled-link': disableAllFields || claimStatus == 'In Process' }" v-on:click="removeOemItem(index);"> <i class="fp-delete"></i> </a>
                  </template>
                  <template v-else>
                    <span class="close-row"> _ </span>
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="btn-groups mb-4">
          <template>
            <button type="submit" v-on:click.prevent="addOemRow()" class="btn btn-primary" :disabled="disableAll || disableAllFields || claimStatus == 'In Process'">
              <i class="fp-add"></i> Add Additional Parts
            </button>
          </template>
        </div>
      </div>
    </template>
    <!-- Attachment Section starts -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div v-if="partAttachmentLink == null" class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> Attachment </h3>
            <input type="file" :disabled="noPartsUsed || disableAllFields" ref="partFileInput" @change="handleSelectedFile($event)"
              :id="'uploadFile'">
            <div class="field-error ml-0">{{ partFileErrorMsg }}</div>
          </div>
          <div v-else class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> Attachment Link </h3>
            <div class="row">
              <div class="col d-flex align-items-center">
                <a v-on:click="goToGetDocumentPath($event, partAttachmentLink)" title="View Part Attachment"
                  href="javascript:void(0);" style="font-size: 15px;">
                  <i class="fp-text-document"></i> Part Attachment
                </a>
                <a href="javascript:void(0);" style="margin-left: 15px;margin-top: 4px;"
                  v-on:click="removePartAttachmentLink();" class="ms-1" :class="{ 'custom-disabled-link': disableAllFields || claimStatus == 'In Process' }">
                  <i class="fp-remove"></i>
                </a>
              </div>
              <div class="col"></div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Attachment Section ends -->


    <!-- The summary section starts -->
    <div class="order-summary mt-4">
      <div class="row">
        <div class="col-md-12">
          <div class="bg-white radius-5 p-3">
            <h3 class="color-darkblue"> Parts Summary </h3>
            <table class="table table-sm table-bordered">
              <thead>
                <tr class="table-primary">
                  <th class="text-center">Section Summary</th>
                  <th class="text-center">Requested</th>
                  <th class="text-center">Adjusted</th>
                  <th class="text-center">Approved</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-secondary">
                  <td class="text-center">Parts</td>
                  <td class="text-center">$ {{ amountFormat(totalPartRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalPartAdjustedAmount, 2, 'total')
                    }}
                  </td>
                  <td class="text-center">$ {{ amountFormat(totalPartApprovedAmount) }}</td>
                </tr>
                <tr class="table-secondary">
                  <td class="text-center">Non-OEM Parts</td>
                  <td class="text-center">$ {{ amountFormat(totalNonOemPartRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalNonOemPartAdjustedAmount, 2,
            'total')
                    }}</td>
                  <td class="text-center">$ {{ amountFormat(totalNonOemPartApprovedAmount) }}</td>
                </tr>
                <tr class="table-secondary">
                  <td class="text-center">Total</td>
                  <td class="text-center">$ {{ amountFormat(totalRequestedAmount) }}</td>
                  <td class="text-center">$ {{ formatNegativeValueWithParentheses(totalAdjustedAmount, 2, 'total') }}
                  </td>
                  <td class="text-center">$ {{ amountFormat(totalApprovedAmount) }}</td>
                </tr>
              </tbody>

            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- The summary section ends -->
    <template>
      <div class="alert alert-warning hide w-50">
        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span
            aria-hidden="true">&times;</span></button>
        <strong class="errormsg"></strong>
      </div>
    </template>

  </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from '../../mixins/commonMixins';
import LoadingContent from "@/components/LoadingContent.vue";
Vue.component("loading-content", LoadingContent);

import vue2Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

export default {
  name: "EvPartTab",
  components: {
    vueDropzone: vue2Dropzone,
  },
  mixins: [commonMixins],
  props: {
    viewAllfields: {
      type: Boolean,
      default: false
    },
    dealerFieldsDisabled: {
      type: Boolean,
      default: false
    },
    disableAllFields: {
      type: Boolean,
      default: false
    },
    claimStatus: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    permissions: [],
    rows: [],
    oem_rows: [],
    partTotalTable: [],
    disableAll: false,
    componentArr: [],
    totalClaimedAmount: 0,
    totalProcessedAmount: 0,
    handlingTotalAmount: 0,
    handlingProcessedAmount: 0,
    netTotalAmount: 0,
    netProcessedAmount: 0,
    require: false,
    attachmentRequired: false,
    nonOemPartArr: [{ value: 'liquid gasket', text: 'Liquid Gasket' }, { value: 'grease', text: 'Grease' },
    { value: 'oil', text: 'Oil' }, { value: 'coolant', text: 'Coolant' }, { value: 'zip ties', text: 'Zip Ties' },
    { value: 'other', text: 'Other' }],
    nonOemPartClaimAmountTotal: 0,
    nonOemPartProcessedAmountTotal: 0,
    partAttachment: null,
    canViewPartCalimedPrice: false,
    section_verified: false,
    approvalStatusArr: ['Accepted', 'Rejected'],
    dispositionArr: ['Return', 'Scrap/Recycle', 'Hold', 'N/A'],
    displayNonOemPartSection: false,

    totalPartRequestedAmount: 0,
    totalPartAdjustedAmount: 0,
    totalPartApprovedAmount: 0,
    totalNonOemPartRequestedAmount: 0,
    totalNonOemPartAdjustedAmount: 0,
    totalNonOemPartApprovedAmount: 0,
    totalRequestedAmount: 0,
    totalAdjustedAmount: 0,
    totalApprovedAmount: 0,

    partFileErrorMsg: "",
    partDetailId: "",
    rowsToDelete: [],
    nonOemRowsToDelete: [],
    partAttachmentLink: null,
    noPartsUsed: false,
    tempPartsRow: [],
    tempNonOemPartsRow: [],
    checkPart: true,
    tempRowsToDelete: [],
    tempNonOemRowsToDelete: [],
    userObj: JSON.parse(localStorage.getItem("user_obj")),
    initialPartData: '',
    currentPartData: ''
  }),
  watch: {
    permissions: function (permissions) {
      let self = this;
      if (permissions.length > 0) {
        for (const element of permissions) {
          if (element.name == 'ev_view_part_claimed_price') {
            self.canViewPartCalimedPrice = true;
            break;
          } else {
            self.canViewPartCalimedPrice = false;
          }
        }
      }

    },
    noPartsUsed: function (value) {
      if (this.checkPart) {
        if (value) {
          if (this.rows.length > 0 || this.oem_rows.length > 0) {
            this.$swal({
              title: "Are you sure you want no parts to be selected!",
              type: 'warning',
              confirmButtonText: 'Yes',
              cancelButtonText: 'No',
              showCancelButton: true,
            }).then((result) => {
              if (result.value) {
                this.deletePartLineItemsWhenNoPartSelected();
              } else {
                this.noPartsUsed = false;
                this.checkPart = false;
              }
            });
          }

        } else {
          this.addPartLineItemsWhenPartSelected();
        }
      } else {
        this.checkPart = true;
      }
    }

  },
  mounted() {
    var self = this;
    self.getPermissions();
    var path = window.location.pathname;
    var segments = path.split("/");
    if (!segments[3]) {
      self.rows.push(
        {
          id: "",
          part: "",
          partDescription: "",
          qty: '',
          warranty_price: '',
          line_total: '',
          root_cause_part: false,
          approval_status: "",
          approval_price: '',
          disposition: "",
          rejectionReason: "",
          rejectionReasonErrorMsg: "",
          part_number_error_msg: "",
          qty_error_msg: "",
          warranty_price_error_msg: "",
          root_cause_part_error_msg: "",
          approval_status_error_msg: "",
          approval_price_error_msg: "",
          created_by: self.userObj.id
        },
      );

      self.populatePartTotalTable();
    }
  },
  methods: {
    partNumberChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.rows[index] != undefined)
      {
        this.rows[index].part = '';
      }
    },
    partApprovalStatusChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.rows[index] != undefined)
      {
        this.rows[index].approval_status = '';
      }
      this.handlePartsApprovalStatusChange(index);
    },
    handlePartsApprovalStatusChange(index) {
      const row = this.rows[index];
      if (!row) return;

      const status = row.approval_status;
      
      if (!status || status === 'Rejected') {
        row.approval_price = '';
      } else {
        row.approval_price = row.line_total;
      }
    },
    nonOemPartApprovalStatusChanged(value, index){
      if(
        (value == '' || value == null)
        &&
        this.oem_rows[index] != undefined)
      {
        this.oem_rows[index].approvalStatus = '';
      }
      this.handleNonOemPartsApprovalStatusChange(index);
    },
    handleNonOemPartsApprovalStatusChange(index){
      const row = this.oem_rows[index];
      if (!row) return;

      const status = row.approvalStatus;

      if (!status || status === 'Rejected') {
        row.approvalPrice = '';
      } else {
        row.approvalPrice = row.requested_total;
      }
    },
    gotoNext: function (flag) {
      var self = this;
      // var success = self.validateAllRowsForSend();
      // if (success) {
      self.emitDataToParent();
      self.gotoNextStepMixins(flag);
      // }
    },
    gotoBack: function (flag) {
      var self = this;
      self.gotoBackStepMixins(flag);
    },
    addRow(flag = '') {
      var self = this;
      if (flag == 'add') {
        var success = true;
      } else {
        var success = true;
        for (var i = 0; i < self.rows.length; i++) {
          success = self.validatePartsRowData(i);
        }
      }
      if (success) {
        self.rows.push(
          {
            id: "",
            part: "",
            partDescription: "",
            qty: '',
            warranty_price: '',
            line_total: '',
            root_cause_part: false,
            approval_status: "",
            approval_price: '',
            disposition: "",
            rejectionReason: "",
            rejectionReasonErrorMsg: "",
            part_number_error_msg: "",
            qty_error_msg: "",
            warranty_price_error_msg: "",
            root_cause_part_error_msg: "",
            approval_status_error_msg: "",
            approval_price_error_msg: "",
            approval_price_change: false,
            created_by: self.userObj.id
          },
        );
      }
    },
    addOemRow() {
      var self = this;
      var success = true;

      for (var i = 0; i < self.oem_rows.length; i++) {
        success = self.validateNonOemPartsRowData(i);
      }
      if (success) {
        self.oem_rows.push({
          id: "",
          partNumber: '',
          partDescription: "",
          qty: '',
          dealerCost: '',
          requested_total: '',
          reason: "",
          approvalStatus: "",
          approvalPrice: '',
          disposition: "",
          rejectionReason: "",
          rejectionReasonErrorMsg: "",
          part_number_error_msg: '',
          qty_error_msg: "",
          dealer_cost_error_msg: "",
          requested_error_msg: "",
          reason_error_msg: "",
          approval_status_error_msg: "",
          approval_price_error_msg: "",
          approval_price_change: false,
          created_by: self.userObj.id
        });
      }
    },
    onSearchComponent(search, loading) {
      var self = this;
      if (search.length > 2) {

        loading(true);
        self.location_error_msg = "";
        self.searchField(loading, search, 'part_number');
      }
    },
    removeItem(index) {
      var self = this;
      if (self.rows[index].partAttachmentPath != null) {
        self.deleteAttachment(index, "partAttachment"); // only call this function if the attachment is not null
      }
      if (self.rows.length > 1) {
        if (self.rows[index].id != "") {
          self.rowsToDelete.push({
            id: self.rows[index].id
          });
        }
        if (self.rows[index].root_cause_part) {
          self.emitPartNumberToParent(null);
        }
        self.rows.splice(index, 1);
      }
      self.calculatePartsAmount();
    },
    removeOemItem(index) {
      var self = this;
      if (self.oem_rows[index].attachmentPath != null) {
        self.deleteAttachment(index, "nonOemPartAttachment"); // only call this function if the attachment is not null
      }
      if (self.oem_rows.length > 0) {
        if (self.oem_rows[index].id != "") {
          self.nonOemRowsToDelete.push({
            id: self.oem_rows[index].id
          });
        }
        self.oem_rows.splice(index, 1);
      }
      self.calculateNonOemPartsAmount();
    },
    populatePartTotalTable() {
      var self = this;
      self.partTotalTable.push(
        {
          heading: "Total Amount",
          claimed_amount: self.totalClaimedAmount,
          processed_amount: 0.00,
        },
        {
          heading: "Total Handling",
          claimed_amount: 0.00,
          processed_amount: 0.00,
        },
        {
          heading: "Net Total",
          claimed_amount: 0.00,
          processed_amount: 0.00,
        }
      )
    },
    validatePartsRowData(index) {
      var self = this;
      var success = true;

      if ((!self.noPartsUsed) && self.rows.length > 0) {
        self.clearRowErrorMessages(index);
        if (self.rows[index].part == null || self.rows[index].part == "") {
          success = false;
          self.rows[index].part_number_error_msg = "Part Number Required";
        }
        if (self.rows[index].qty == null || self.rows[index].qty == "") {
          success = false;
          self.rows[index].qty_error_msg = "Quantity Required";
        }
        if (self.rows[index].warranty_price == null || self.rows[index].warranty_price == "" || self.rows[index].warranty_price == 0) {
          success = false;
          self.rows[index].warranty_price_error_msg = "Warranty Price Required";
        }
        if (self.viewAllfields) {
          if (self.rows[index].approval_status == null || self.rows[index].approval_status == "") {
            success = false;
            self.rows[index].approval_status_error_msg = "Approval Status Required";
          }
          if (self.rows[index].approval_price == null || self.rows[index].approval_price == "") {
            success = false;
            self.rows[index].approval_price_error_msg = "Approval Price Required";
          }
          if (self.rows[index].approval_status == "Rejected") {
            if (self.rows[index].rejectionReason == null || self.rows[index].rejectionReason == "") {
              success = false;
              self.rows[index].rejectionReasonErrorMsg = "Rejection Reason Required";
            }
          }
        }
      }
      return success;
    },
    validateNonOemPartsRowData(index) {
      var self = this;
      var success = true;
      if (self.oem_rows[index] !== undefined) {
        self.clearNonOemRowErrorMessages(index);
        if (self.oem_rows.length > 0) {
          if (self.oem_rows[index].partNumber == null || self.oem_rows[index].partNumber == "") {
            self.oem_rows[index].part_number_error_msg = "Part Number Required";
            success = false;
          }
          if (self.oem_rows[index].qty == null || self.oem_rows[index].qty == "") {
            self.oem_rows[index].qty_error_msg = "Quantity Required";
            success = false;
          }
          if (self.oem_rows[index].qty === 0) {
            self.oem_rows[index].qty_error_msg = "Quantity should be greater than zero!";
            success = false;
          }
          if (self.oem_rows[index].dealerCost == null || self.oem_rows[index].dealerCost == "") {
            self.oem_rows[index].dealer_cost_error_msg = "Dealer Cost Required";
            success = false;
          }

          if (self.viewAllfields) {
            if (self.oem_rows[index].approvalStatus == null || self.oem_rows[index].approvalStatus == '') {
              success = false;
              self.oem_rows[index].approval_status_error_msg = "Approval Status Required";
            }
            if (self.oem_rows[index].approvalPrice == null || self.oem_rows[index].approvalPrice == '') {
              success = false;
              self.oem_rows[index].approval_price_error_msg = "Approval Price Required";
            }
            if (self.oem_rows[index].approvalStatus == "Rejected") {
              if (self.oem_rows[index].rejectionReason == null || self.oem_rows[index].rejectionReason == "") {
                success = false;
                self.oem_rows[index].rejectionReasonErrorMsg = "Rejection Reason Required";
              }
            }
          }
        }
      }

      return success;
    },
    clearRowErrorMessages(index) {
      var self = this;
      self.rows[index].part_number_error_msg = "";
      self.rows[index].qty_error_msg = "";
      self.rows[index].warranty_price_error_msg = "";
      self.rows[index].root_cause_part_error_msg = "";
      self.rows[index].approval_status_error_msg = "";
      self.rows[index].approval_price_error_msg = "";
      self.rows[index].rejectionReasonErrorMsg = "";
    },
    clearNonOemRowErrorMessages(index) {
      var self = this;

      self.oem_rows[index].part_number_error_msg = "";
      self.oem_rows[index].qty_error_msg = "";
      self.oem_rows[index].dealer_cost_error_msg = "";
      self.oem_rows[index].reason_error_msg = "";
      self.oem_rows[index].approval_status_error_msg = "";
      self.oem_rows[index].approval_price_error_msg = "";
      self.oem_rows[index].rejectionReasonErrorMsg = "";
    },
    validateAllRowsForSend() {
      var self = this;
      var partLineItemSuccess = true;
      var nonOemLineItemSuccess = true;
      var overallSuccess = true;
      self.partFileErrorMsg = "";

      for (var i = 0; i < self.rows.length; i++) {
        partLineItemSuccess = self.validatePartsRowData(i);
        if (!partLineItemSuccess) {
          overallSuccess = false;
        }
      }
      if (self.displayNonOemPartSection) {
        for (var i = 0; i < self.oem_rows.length; i++) {
          nonOemLineItemSuccess = self.validateNonOemPartsRowData(i);
          if (!nonOemLineItemSuccess) {
            overallSuccess = false;
          }
        }
      }

      if (!self.noPartsUsed) {
        if (self.partAttachmentLink == null && self.oem_rows.length > 0) {
          if (self.partAttachment == null || self.partAttachment == "") {
            overallSuccess = false;
            self.partFileErrorMsg = "Part Attachment is Required";
          }
        }
      }

      if (overallSuccess) {
        return true;
      } else {
        return false;
      }
    },
    emitDataToParent() {
      var self = this;
      self.beforeEmitDataToParent();

      const dataToSend = {
        rows: this.rows,
        nonOemRows: self.oem_rows,
        verified: self.section_verified,
        totalPartRequestedAmount: self.totalPartRequestedAmount.toFixed(2),
        totalPartAdjustedAmount: self.totalPartAdjustedAmount.toFixed(2),
        totalPartApprovedAmount: self.totalPartApprovedAmount.toFixed(2),
        totalNonOemPartRequestedAmount: self.totalNonOemPartRequestedAmount.toFixed(2),
        totalNonOemPartAdjustedAmount: self.totalNonOemPartAdjustedAmount.toFixed(2),
        totalNonOemPartApprovedAmount: self.totalNonOemPartApprovedAmount.toFixed(2),
        totalRequestedAmount: self.totalRequestedAmount.toFixed(2),
        totalAdjustedAmount: self.totalAdjustedAmount.toFixed(2),
        totalApprovedAmount: self.totalApprovedAmount.toFixed(2),
        partDetailId: self.partDetailId,
        rowsToDelete: self.rowsToDelete,
        nonOemRowstoDelete: self.nonOemRowsToDelete,
        partAttachmentLink: self.partAttachmentLink,
      };
      self.$emit("send-part-data-to-parent", dataToSend);
    },
    beforeEmitDataToParent() {
      var self = this;
      self.rows.forEach((row) => {
        if (row.warranty_price) {
          row.warranty_price = self.customFunctionForAmountFormat(row.warranty_price);
          row.warranty_price = parseFloat(row.warranty_price).toFixed(2);
        }
        if (row.line_total) {
          row.line_total = self.customFunctionForAmountFormat(row.line_total);
          row.line_total = parseFloat(row.line_total).toFixed(2);
        }
        if (row.approval_price) {
          row.approval_price = self.customFunctionForAmountFormat(row.approval_price);
          row.approval_price = parseFloat(row.approval_price).toFixed(2);
        }
        if (row.approval_price == '') {
          row.approval_price = '0.00';
        }
      });
      if (self.displayNonOemPartSection && self.oem_rows.length) {
        self.oem_rows.forEach((row) => {
          if (row.dealerCost) {
            row.dealerCost = self.customFunctionForAmountFormat(row.dealerCost);
            row.dealerCost = parseFloat(row.dealerCost).toFixed(2);
          }
          if (row.requested_total) {
            row.requested_total = self.customFunctionForAmountFormat(row.requested_total);
            row.requested_total = parseFloat(row.requested_total).toFixed(2);
          }
          if (row.approvalPrice) {
            row.approvalPrice = self.customFunctionForAmountFormat(row.approvalPrice);
            row.approvalPrice = parseFloat(row.approvalPrice).toFixed(2);
          }
          if (row.approvalPrice == '') {
            row.approvalPrice = '0.00';
          }
        });
      }
    },
    validationFail() {
      var self = this;
      self.rows.forEach((row) => {
        if (row.warranty_price) {
          row.warranty_price = self.formatCurrency(row.warranty_price);
        }
        if (row.line_total) {
          row.line_total = self.formatCurrency(row.line_total);
        }

        row.approval_price = self.customFunctionForAmountFormat(row.approval_price);
        if (row.approval_price == 0 || row.approval_price == '') {
          row.approval_price = ''
        } else {
          row.approval_price = self.formatCurrency(row.approval_price);
        }
      });
      if (self.displayNonOemPartSection && self.oem_rows.length) {
        self.oem_rows.forEach((row) => {
          row.dealerCost = self.formatCurrency(row.dealerCost);
          row.requested_total = self.formatCurrency(row.requested_total);

          row.approvalPrice = self.customFunctionForAmountFormat(row.approvalPrice);
          if (row.approvalPrice == 0 || row.approvalPrice == '') {
            row.approvalPrice = '';
          } else {
            row.approvalPrice = self.formatCurrency(row.approvalPrice);
          }
        });
      }
    },
    calculatePartsAmount(flag = false) {
      var self = this;

      self.totalPartRequestedAmount = 0;
      self.totalPartAdjustedAmount = 0;
      self.totalPartApprovedAmount = 0;

      for (let element of self.rows) {
        // Format amounts and ensure numerical values
        if (element.warranty_price !== '') {
          element.warranty_price = self.customFunctionForAmountFormat(element.warranty_price);
        }
        if (element.line_total) {
          element.line_total = self.customFunctionForAmountFormat(element.line_total);
        }
        if (element.approval_price) {
          element.approval_price = self.customFunctionForAmountFormat(element.approval_price);
        }

        if (element.qty && element.warranty_price) {
          element.qty = parseInt(element.qty);
          element.line_total = element.qty * element.warranty_price;
        } else {
          element.line_total = '';
          element.approval_price = '';
        }

        if (element.line_total) {
          self.totalPartRequestedAmount += element.line_total;
        }

        if (flag) {
          element.approval_price = element.line_total;
        }

        if (element.approval_price) {
          self.totalPartApprovedAmount += parseFloat(element.approval_price);
        }

        // Calculate adjusted amount
        if (element.line_total && element.approval_price) {
          let adjustedPrice = parseFloat(element.approval_price) - element.line_total;
          self.totalPartAdjustedAmount += adjustedPrice;
        }

        // Format warranty price and line total with $ sign
        if (element.approval_price) {
          element.approval_price = element.approval_price ? '$' + element.approval_price : '$0';
        }
        if (element.warranty_price !== '') {
          element.warranty_price = element.warranty_price != 0 ? '$' + element.warranty_price : '$0';
        }
        if (element.line_total) {
          element.line_total = element.line_total ? '$' + self.amountFormat(element.line_total) : '$0';
        }
      }
      self.calculateTotals();
    },
    calculateNonOemPartsAmount(flag = false) {
      var self = this;

      self.totalNonOemPartRequestedAmount = 0;
      self.totalNonOemPartAdjustedAmount = 0;
      self.totalNonOemPartApprovedAmount = 0;

      for (let element of self.oem_rows) {
        // Format amounts and ensure numerical values
        if (element.dealerCost) {
          element.dealerCost = self.customFunctionForAmountFormat(element.dealerCost);
        }
        if (element.requested_total) {
          element.requested_total = self.customFunctionForAmountFormat(element.requested_total);
        }
        if (element.approvalPrice) {
          element.approvalPrice = self.customFunctionForAmountFormat(element.approvalPrice);
        }

        if (element.qty && element.dealerCost) {
          element.qty = parseInt(element.qty);
          element.requested_total = element.qty * element.dealerCost;
        } else {
          element.requested_total = '';
          element.approvalPrice = '';
        }

        if (element.requested_total) {
          self.totalNonOemPartRequestedAmount += element.requested_total;
        }

        if (flag) {
          element.approvalPrice = element.requested_total;
        }

        if (element.approvalPrice) {
          self.totalNonOemPartApprovedAmount += parseFloat(element.approvalPrice);
        }

        // Calculate adjusted amount
        if (element.requested_total && element.approvalPrice) {
          let adjustedPrice = parseFloat(element.approvalPrice) - element.requested_total;
          self.totalNonOemPartAdjustedAmount += adjustedPrice;
        }

        // Format dealer cost and requested amount with $ sign
        if (element.approvalPrice) {
          element.approvalPrice = element.approvalPrice ? '$' + element.approvalPrice : '$0';
        }
        if (element.dealerCost) {
          element.dealerCost = element.dealerCost ? '$' + element.dealerCost : '$0';
        }
        if (element.requested_total) {
          element.requested_total = element.requested_total ? '$' + self.amountFormat(element.requested_total) : '$0';
        }
      }
      self.calculateTotals();
    },
    calculateTotals() {
      var self = this;

      self.totalRequestedAmount = 0;
      self.totalAdjustedAmount = 0;
      self.totalApprovedAmount = 0;

      // FOR PARTS
      // Ensure values are numbers before summing
      self.totalPartRequestedAmount = self.amountFormatToFloat(self.totalPartRequestedAmount);
      self.totalPartApprovedAmount = self.amountFormatToFloat(self.totalPartApprovedAmount);

      self.totalAdjustedAmount = self.totalAdjustedAmount + self.formatAmountToFloatNew(self.totalPartAdjustedAmount);

      self.totalApprovedAmount += self.totalPartApprovedAmount;
      self.totalRequestedAmount += self.totalPartRequestedAmount;

      // FOR NON OEM PARTS
      // Ensure values are numbers before summing
      self.totalNonOemPartRequestedAmount = self.amountFormatToFloat(self.totalNonOemPartRequestedAmount);
      self.totalNonOemPartApprovedAmount = self.amountFormatToFloat(self.totalNonOemPartApprovedAmount);

      self.totalAdjustedAmount = self.totalAdjustedAmount + self.formatAmountToFloatNew(self.totalNonOemPartAdjustedAmount);

      self.totalRequestedAmount += self.totalNonOemPartRequestedAmount;
      self.totalApprovedAmount += self.totalNonOemPartApprovedAmount;


      var calculationData = {
        totalRequestedAmount: self.totalRequestedAmount,
        totalAdjustedAmount: self.formatAmountToFloatNew(self.totalAdjustedAmount),
        totalApprovedAmount: self.totalApprovedAmount
      };
      self.$emit("send-calculation-part-data-to-parent", calculationData);
    },
    getPartLineItems(lineItemData) {
      var self = this;
      if (lineItemData.length > 0) {
        self.rows = [];
        for (const element of lineItemData) {
          element.part_claimed_price = "$" + this.amountFormat(element.part_claimed_price);
          element.processed = "$" + this.amountFormat(element.processed);
          element.handling_amount = "$" + this.amountFormat(element.handling_amount);
          element.total = "$" + this.amountFormat(element.total);
          self.rows.push(element);
        }
      }
    },
    getPartTotals(totalData) {
      var self = this;
      self.totalClaimedAmount = totalData.part_total_claim_amount;
      self.totalProcessedAmount = totalData.part_total_processed_amount;
      self.handlingTotalAmount = totalData.part_handling_total_amount;
      self.handlingProcessedAmount = totalData.part_handling_total_processed_amount;
      self.netTotalAmount = totalData.part_net_total_amount;
      self.netProcessedAmount = totalData.part_net_total_processed_amount;
      if (totalData.non_oem_parts != null) {
        self.oem_rows = totalData.non_oem_parts;
      }
      self.nonOemPartClaimAmountTotal = totalData.non_oem_part_total_claim_amount;
      self.nonOemPartProcessedAmountTotal = totalData.non_oem_part_total_processed_amount;
    },
    calculateWarrantyPrice(index){
      var self = this;
      var basePrice = parseFloat(self.rows[index].part.base_price);
      var finalPrice = 0;

      if (isNaN(basePrice)) {
        alert('Invalid base price. Please refresh and try again. If the issue persists, please contact the admin.');
        return;  // Exit early if basePrice is invalid
      } else {
        if (basePrice <= 2499.99) {
          finalPrice = basePrice * 1.30;
        } else {
          finalPrice = basePrice * 1.10; // No need to check >= 2500 since it's the only other option
        }
      }
      // Ensure warranty_price is stored as a number, not a string
      self.rows[index].warranty_price = parseFloat(finalPrice.toFixed(2));
    },
    populatePartsDescription(index) {
      var self = this;
      if (self.rows[index].part != undefined && self.rows[index].part != "" && self.rows[index].part != null) {
        self.clearFields(index);
        self.rows[index].partDescription = self.rows[index].part.description;
        self.rows[index].require = true;
        self.calculateWarrantyPrice(index);
        self.calculatePartsAmount();
      } else {
        self.rows[index].part = "";
        self.rows[index].part_number_error_msg = "";
        self.rows[index].partDescription = "";
        self.rows[index].qty = '';
        self.rows[index].qty_error_msg = "";
        self.rows[index].warranty_price = '',
          self.rows[index].line_total = '',
          self.rows[index].warranty_price_error_msg = "";
        self.rows[index].root_cause_part = false;
        self.rows[index].root_cause_part_error_msg = "";
        self.rows[index].approval_status = "";
        self.rows[index].approval_price = "";
        self.rows[index].approval_price_error_msg = "";
        self.rows[index].disposition = "";
        self.rows[index].rejectionReason = "";
        self.rows[index].rejectionReasonErrorMsg = "";
      }
    },
    populateNonOemPartsDescription(index) {
      var self = this;
      if (self.oem_rows[index].partNumber != undefined && self.oem_rows[index].partNumber != "" && self.oem_rows[index].partNumber != null) {
        self.oem_rows[index].partDescription = self.oem_rows[index].partNumber.description;
        self.oem_rows[index].require = true;
      } else {
        self.oem_rows[index].partNumber = '';
        self.oem_rows[index].part_number_error_msg = '';
        self.oem_rows[index].partDescription = "";
        self.oem_rows[index].qty = 0;
        self.oem_rows[index].qty_error_msg = "";
        self.oem_rows[index].dealerCost = 0;
        self.oem_rows[index].dealer_cost_error_msg = "";
        self.oem_rows[index].requested_total = 0;
        self.oem_rows[index].requested_error_msg = "";
        self.oem_rows[index].reason = "";
        self.oem_rows[index].reason_error_msg = "";
        self.oem_rows[index].approvalStatus = '';
        self.oem_rows[index].approvalPrice = 0;
        self.oem_rows[index].disposition = '';
        self.oem_rows[index].rejectionReason = "";
        self.oem_rows[index].rejectionReasonErrorMsg = "";
      }
    },
    checkAttachmentRequired() {
      var self = this;
      for (let i = 0; i < self.rows.length; i++) {
        if (self.rows[i].user_input_price > 0) {
          self.attachmentRequired = true;
          break;
        }
      }
    },
    calculateNonOemPartRowTotal(index) {
      var self = this;
      self.oem_rows[index].invoice = 0;
      self.oem_rows[index].attachmentError = "";
      self.oem_rows[index].attachmentRequired = false;

      if (self.oem_rows[index].qty > 0 || self.oem_rows[index].unit_price > 0) {
        if (self.oem_rows[index].unit_price > 10) {
          self.oem_rows[index].attachmentRequired = true;
          if (self.oem_rows[index].attachment == null) {
            self.oem_rows[index].attachmentError = "Attachment Required!";
          }
        }
        self.oem_rows[index].invoice = self.oem_rows[index].qty * self.oem_rows[index].unit_price;
      }
      self.calculateTotalNonOemPartAmount();
    },
    calculateTotalNonOemPartAmount() {
      var self = this;
      self.nonOemPartClaimAmountTotal = 0;
      for (let oemPart of self.oem_rows) {
        if (typeof oemPart.invoice === 'string') {
          oemPart.invoice = parseFloat(oemPart.invoice);
        }
        self.nonOemPartClaimAmountTotal = self.nonOemPartClaimAmountTotal + oemPart.invoice;
      }
      self.calculateTotalClaimAmount();
    },
    partAttachmentUpload(index, event) {
      this.rows[index].partAttachment = event.target.files[0];
      this.rows[index].partAttachmentError = "";
    },

    nonOemPartAttachmentUpload(index, event) {
      this.oem_rows[index].attachment = event.target.files[0];
      this.oem_rows[index].attachmentError = "";
    },
    showNonOemSection() {
      if (!this.displayNonOemPartSection) {
        this.displayNonOemPartSection = true;
        this.addOemRow();
      }
    },
    handleSelectedFile(event) {
      var self = this;
      self.partFileErrorMsg = '';
      const file = event.target.files[0]; // Get the selected file
      if (file) {
        // Handling file
        const maxSize = 10000000; // 10MB
        if (file.size > maxSize) {
          self.partFileErrorMsg = "The file size is too large. Please upload a file smaller than 10MB.";
        } else {
          self.partAttachment = file;
          self.$emit("send-part-attachment-data-to-parent", self.partAttachment);
        }
      }
    },
    rootCausePartChecked(index, flag = '') {
      if (this.rows.length > 0) {
        for (let i = 0; i < this.rows.length; i++) {
          if (i != index) {
            this.rows[i].root_cause_part = false;
          }
        }
      }

      if (flag == 'no-parts') {
        this.emitPartNumberToParent(flag);
      } else {
        this.noPartsUsed = false;
        if ((this.rows[index].part != "" || this.rows[index].part != null) && this.rows[index].root_cause_part == true) {
          this.emitPartNumberToParent(index);
        } else {
          this.emitPartNumberToParent(null);
        }
      }
    },
    handlePartNumberChange(index) {
      this.rows[index].approval_price_change = false;
      this.checkRootCausePartChange(index);
    },
    clearFields(index) {
      this.rows[index].partDescription = '';
      this.rows[index].qty = '';
      this.rows[index].warranty_price = '',
        this.rows[index].line_total = '',
        this.rows[index].root_cause_part = false;
      this.rows[index].approval_status = "";
      this.rows[index].approval_price = "";
      this.rows[index].disposition = "";
      this.rows[index].rejectionReason = "";
    },
    checkRootCausePartChange(index) {
      if (this.rows[index].root_cause_part == true) {
        if (this.rows[index].part != "" || this.rows[index].part != null) {
          this.emitPartNumberToParent(index);
        }
      }
    },
    emitPartNumberToParent(index) {
      if (index == null) {
        this.$emit("send-part-number-to-parent", [null, null]);
      } else if (index == 'no-parts') {
        this.$emit("send-part-number-to-parent", ['no-parts', this.noPartsUsed]);
      } else {
        this.$emit("send-part-number-to-parent", [this.rows[index].part, null]);
      }
    },
    goToGetDocumentPath(event, link) {
      event.preventDefault();
      var self = this;
      var path = link;
      var flag = '';
      var id = 0;
      self.getDocumentPath(id, path, flag);
    },
    removePartAttachmentLink() {
      this.partAttachmentLink = null;
    },
    getDataFromParent(partData) {
      this.populatePartLineItems(partData.ev_part_line_items);
      if (
        partData.ev_non_oem_part_line_items != null
        ||
        partData.ev_non_oem_part_line_items != ''
      ) {
        this.populateNonOemPartLineItems(partData.ev_non_oem_part_line_items);
      }
      this.totalPartRequestedAmount = partData.total_part_requested_amount;
      this.totalPartAdjustedAmount = partData.total_part_adjusted_amount;
      this.totalPartApprovedAmount = partData.total_part_approved_amount;
      this.totalNonOemPartRequestedAmount = partData.total_non_oem_part_requested_amount;
      this.totalNonOemPartAdjustedAmount = partData.total_non_oem_part_adjusted_amount;
      this.totalNonOemPartApprovedAmount = partData.total_non_oem_part_approved_amount;
      this.totalRequestedAmount = partData.total_requested_amount;
      this.totalAdjustedAmount = partData.total_adjusted_amount;
      this.totalApprovedAmount = partData.total_approved_amount;
      this.partDetailId = partData.id;
      this.section_verified = (partData.verified == 0) ? false : true;
      this.partAttachmentLink = (partData.attachment != "") ? partData.attachment : null;

      this.calculatePartsAmount();
      this.calculateNonOemPartsAmount();

      this.$nextTick(() => {
        this.populateInitialPartData(true);
      });
    },
    populateInitialPartData(flag) {
      if(flag) {
        setTimeout(() => {
          this.setInitialValue(flag);
        }, 500);
      } else {
        return this.setInitialValue(flag);
      }
    },
    setInitialValue(flag){
      const processRows = (rows, priceKey) => {
        return rows.map(row => {
          let updatedRow = { ...row };

          Object.keys(updatedRow).forEach(key => {
            if (typeof updatedRow[key] === "string" && updatedRow[key].includes("$")) {
              updatedRow[key] = parseFloat(updatedRow[key].replace(/[^0-9.-]+/g, "")).toFixed(2);
            }

            if (key === priceKey) {
              updatedRow[key] = updatedRow[key] === "" ? "0.00" : updatedRow[key];

              if (!Number.isNaN(parseFloat(updatedRow[key]))) {
                updatedRow[key] = parseFloat(updatedRow[key]).toFixed(2).toString();
              }
            }
          });

          return updatedRow;
        });
      };

      const rows = processRows(this.rows, "approval_price");
      const oem_rows = processRows(this.oem_rows, "approvalPrice");

      const partData = JSON.stringify({
        rows,
        nonOemRows: oem_rows,
        verified: this.section_verified,
        totalPartRequestedAmount: this.totalPartRequestedAmount.toFixed(2),
        totalPartAdjustedAmount: this.totalPartAdjustedAmount.toFixed(2),
        totalPartApprovedAmount: this.totalPartApprovedAmount.toFixed(2),
        totalNonOemPartRequestedAmount: this.totalNonOemPartRequestedAmount.toFixed(2),
        totalNonOemPartAdjustedAmount: this.totalNonOemPartAdjustedAmount.toFixed(2),
        totalNonOemPartApprovedAmount: this.totalNonOemPartApprovedAmount.toFixed(2),
        totalRequestedAmount: this.totalRequestedAmount.toFixed(2),
        totalAdjustedAmount: this.totalAdjustedAmount.toFixed(2),
        totalApprovedAmount: this.totalApprovedAmount.toFixed(2),
        partDetailId: this.partDetailId,
        rowsToDelete: this.rowsToDelete,
        nonOemRowstoDelete: this.nonOemRowsToDelete,
        partAttachmentLink: this.partAttachmentLink,
      });

      if (flag) {
        this.initialPartData = '';
        this.initialPartData = partData;
      } else {
        this.currentPartData = '';
        this.currentPartData = partData;
        
        return this.initialPartData !== this.currentPartData;
      }
    },
    populatePartLineItems(partLineItems) {
      if (partLineItems.length > 0) {
        for (let i = 0; i < partLineItems.length; i++) {
          if(partLineItems[i].part != null){
            var part = { text: partLineItems[i].part.vendor_item_number, value: partLineItems[i].part.id };
            var partDescription = partLineItems[i].part.name;
          }else{
            var part = "";
            var partDescription = "";
          }
          this.rows.push(
            {
              id: partLineItems[i].id,
              part: part,
              partDescription: partDescription,
              qty: partLineItems[i].qty,
              warranty_price: partLineItems[i].warranty_price,
              line_total: partLineItems[i].line_total,
              root_cause_part: (partLineItems[i].root_cause_part == 1) ? true : false,
              approval_status: partLineItems[i].approval_status,
              approval_price: partLineItems[i].approval_amount == '0.00' ? '' : partLineItems[i].approval_amount,
              disposition: partLineItems[i].disposition,
              rejectionReason: partLineItems[i].rejection_reason,
              rejectionReasonErrorMsg: "",
              part_number_error_msg: "",
              qty_error_msg: "",
              warranty_price_error_msg: "",
              root_cause_part_error_msg: "",
              approval_status_error_msg: "",
              approval_price_error_msg: "",
              approval_price_change: partLineItems[i].line_total == partLineItems[i].approval_amount ? false : true,
              created_by: partLineItems[i].created_by === null ? this.userObj.id : partLineItems[i].created_by
            },
          );
        }
      } else {
        this.noPartsUsed = true;
        this.emitPartNumberToParent("no-parts");
      }
    },
    populateNonOemPartLineItems(nonOemPartLineItems) {
      if (nonOemPartLineItems.length > 0) {
        this.displayNonOemPartSection = true;
      }
      for (let i = 0; i < nonOemPartLineItems.length; i++) {
        this.oem_rows.push({
          id: nonOemPartLineItems[i].id,
          partNumber: nonOemPartLineItems[i].part_number,
          partDescription: nonOemPartLineItems[i].part_description,
          qty: nonOemPartLineItems[i].qty,
          dealerCost: nonOemPartLineItems[i].dealer_cost,
          requested_total: nonOemPartLineItems[i].requested_amount,
          reason: nonOemPartLineItems[i].reason,
          approvalStatus: nonOemPartLineItems[i].approval_status,
          approvalPrice: nonOemPartLineItems[i].approval_amount == '0.00' ? '' : nonOemPartLineItems[i].approval_amount,
          disposition: nonOemPartLineItems[i].disposition,
          rejectionReason: nonOemPartLineItems[i].rejection_reason,
          rejectionReasonErrorMsg: "",
          part_number_error_msg: '',
          qty_error_msg: "",
          dealer_cost_error_msg: "",
          requested_error_msg: "",
          reason_error_msg: "",
          approval_status_error_msg: "",
          approval_price_error_msg: "",
          approval_price_change: nonOemPartLineItems[i].requested_amount == nonOemPartLineItems[i].approval_amount ? false : true,
          created_by: nonOemPartLineItems[i].created_by === null ? this.userObj.id : nonOemPartLineItems[i].created_by
        });
      }
    },
    clearAllFields(rePopulate = false) {
      var self = this;
      self.section_verified = false;

      self.displayNonOemPartSection = false;
      self.rows = []
      self.oem_rows = [];
      if (!rePopulate) {
        self.rows.push({
          id: "",
          part: "",
          partDescription: "",
          qty: '',
          warranty_price: '',
          line_total: '',
          root_cause_part: false,
          approval_status: "",
          approval_price: '',
          disposition: "",
          rejectionReason: "",
          rejectionReasonErrorMsg: "",
          part_number_error_msg: "",
          qty_error_msg: "",
          warranty_price_error_msg: "",
          root_cause_part_error_msg: "",
          approval_status_error_msg: "",
          approval_price_error_msg: "",
          created_by: self.userObj.id
        });
        self.oem_rows.push({
          id: "",
          partNumber: '',
          partDescription: "",
          qty: '',
          dealerCost: '',
          requested_total: '',
          reason: "",
          approvalStatus: "",
          approvalPrice: '',
          disposition: "",
          rejectionReason: "",
          rejectionReasonErrorMsg: "",
          part_number_error_msg: '',
          qty_error_msg: "",
          dealer_cost_error_msg: "",
          requested_error_msg: "",
          reason_error_msg: "",
          approval_status_error_msg: "",
          approval_price_error_msg: "",
          created_by: self.userObj.id
        });
      }

      if (self.$refs.partFileInput !== undefined) {
        self.$refs.partFileInput.value = null;
      }
      self.partAttachment = '';

      self.totalPartRequestedAmount = 0;
      self.totalPartAdjustedAmount = 0;
      self.totalPartApprovedAmount = 0;
      self.totalNonOemPartRequestedAmount = 0;
      self.totalNonOemPartAdjustedAmount = 0;
      self.totalNonOemPartApprovedAmount = 0;
      self.totalRequestedAmount = 0;
      self.totalAdjustedAmount = 0;
      self.totalApprovedAmount = 0;
      self.rowsToDelete = [];
      self.nonOemRowsToDelete = [];
    },
    deletePartLineItemsWhenNoPartSelected() {
      // If there are parts
        // back up for previous delete array
        this.tempRowsToDelete = this.rowsToDelete;
        // Push rows to delete array
        this.rows.forEach((row) => {
          if (row.id) {
            this.rowsToDelete.push({ id: row.id });
          }
        });

        // Push OEM rows to delete array
        if (this.oem_rows.length > 0) {
          // back up for previous delete array
          this.tempNonOemRowsToDelete = this.nonOemRowsToDelete;
          this.oem_rows.forEach((row) => {
            if (row.id) {
              this.nonOemRowsToDelete.push({ id: row.id });
            }
          });
        }

      // Clear rows and hide the non-OEM part section
      this.tempNonOemPartsRow = this.oem_rows;
      this.tempPartsRow = this.rows;
      this.rows = [];
      this.displayNonOemPartSection = false;
      this.oem_rows = [];
      this.calculatePartsAmount();
      this.calculateNonOemPartsAmount();
    },
    addPartLineItemsWhenPartSelected() {
      // If parts are not used
        // Populate part rows if temp parts exist
        if (this.tempPartsRow.length > 0) {
          this.rows = this.tempPartsRow;
        }
        // restoring the delete array
        this.rowsToDelete = this.tempRowsToDelete;

        // Populate non-OEM part rows if temp non-OEM parts exist
        if (this.tempNonOemPartsRow.length > 0) {
          this.oem_rows = this.tempNonOemPartsRow;
        }
        // restoring the delete array
        this.nonOemRowstoDelete = this.tempNonOemRowsToDelete;
        this.calculatePartsAmount();
        this.calculateNonOemPartsAmount();
    }
  },
}
</script>
<style>
.checkbox-container {
  text-align: center;
  /* Center-align the content */
}

.checkbox-container input[type="checkbox"] {
  width: 10px;
  /* Adjust the width as needed */
  height: 10px;
  /* Adjust the height as needed */
  transform: scale(1.5);
  /* Scale up the checkbox, adjust the value as needed */
  vertical-align: middle;
  /* Center-align the checkbox vertically */
}

.no-parts-used-checkbox label {
  font-size: 17px;
  color: black;
  margin-bottom: 1px;
}

.no-parts-used-checkbox input[type="checkbox"] {
  transform: scale(1.2)
}
</style>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvPartTab.vue